var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconoOportunidades(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.484,
    height: 15.484,
    viewBox: "0 0 15.484 15.484",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_69296",
    "data-name": "Trazado 69296",
    d: "M-1798.308,0a7.751,7.751,0,0,0-7.742,7.742,7.751,7.751,0,0,0,7.742,7.742,7.751,7.751,0,0,0,7.742-7.742A7.751,7.751,0,0,0-1798.308,0Zm0,14.194a6.459,6.459,0,0,1-6.452-6.452,6.459,6.459,0,0,1,6.452-6.452,6.459,6.459,0,0,1,6.452,6.452A6.459,6.459,0,0,1-1798.308,14.194Zm2.581-5.161a1.938,1.938,0,0,1-1.936,1.936v.645a.645.645,0,0,1-.645.645.645.645,0,0,1-.645-.645v-.645h-.173A1.942,1.942,0,0,1-1800.8,10a.645.645,0,0,1,.235-.881.644.644,0,0,1,.881.235.647.647,0,0,0,.559.323h1.463a.645.645,0,0,0,.645-.645.5.5,0,0,0-.415-.49l-1.962-.327a1.781,1.781,0,0,1-1.494-1.763,1.938,1.938,0,0,1,1.936-1.936V3.871a.645.645,0,0,1,.645-.645.645.645,0,0,1,.645.645v.645h.173a1.943,1.943,0,0,1,1.676.968.645.645,0,0,1-.235.881.644.644,0,0,1-.881-.236.648.648,0,0,0-.559-.323h-1.463a.646.646,0,0,0-.645.645.5.5,0,0,0,.415.49l1.962.327a1.781,1.781,0,0,1,1.494,1.763Z",
    transform: "translate(1806.05)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoOportunidades);
export default __webpack_public_path__ + "static/media/Icono-Oportunidades.9e1dd879d856acd644e3ff771e37f791.svg";
export { ForwardRef as ReactComponent };